import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppFacade } from '@shared/state/facades';
import { finalize, Observable } from 'rxjs';

@Injectable()
export class LoaderHttpInterceptor implements HttpInterceptor {
  private excludedUrls = [
    'assets/icons/material',
    'app/grid/svg-icons',
    'api/heartbeat',
    'api/dpr/getdprattachmentsinfo',
    'files/zip-archive',
    'files/download',
    'zendesk/messaging-token',
  ];

  constructor(private appFacade: AppFacade) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    for (const url of this.excludedUrls) {
      if (req.url.includes(url)) {
        return next.handle(req);
      }
    }

    setTimeout(() => {
      this.appFacade.showLoader();
    });
    return next.handle(req).pipe(
      finalize(() => {
        setTimeout(() => {
          this.appFacade.hideLoader();
        });
      })
    );
  }
}
